// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IOcrServiceDateOptionDto
 */
export interface IOcrServiceDateOptionDto {
    /**
     * 
     * @type {Date}
     * @memberof IOcrServiceDateOptionDto
     */
    date?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof IOcrServiceDateOptionDto
     */
    is_suggested?: boolean;
}

/**
 * Check if a given object implements the IOcrServiceDateOptionDto interface.
 */
export function instanceOfIOcrServiceDateOptionDto(value: object): value is IOcrServiceDateOptionDto {
    return true;
}

export function IOcrServiceDateOptionDtoFromJSON(json: any): IOcrServiceDateOptionDto {
    return IOcrServiceDateOptionDtoFromJSONTyped(json, false);
}

export function IOcrServiceDateOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOcrServiceDateOptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'is_suggested': json['is_suggested'] == null ? undefined : json['is_suggested'],
    };
}

export function IOcrServiceDateOptionDtoToJSON(json: any): IOcrServiceDateOptionDto {
    return IOcrServiceDateOptionDtoToJSONTyped(json, false);
}

export function IOcrServiceDateOptionDtoToJSONTyped(value?: IOcrServiceDateOptionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'] == null ? undefined : ((value['date']).toISOString().substring(0,10)),
        'is_suggested': value['is_suggested'],
    };
}

